'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDay$002dOf$002dWeek$002dUtils$0024$0024anon$002410 from "./presto.types$-Day-Of-Week-Utils$$anon$10.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DayOfWeekUtils$() {
  this.c4A = null;
  this.c4B = false;
  this.c4y = null;
  this.c4z = false;
}
export { $c_Lpresto_types$DayOfWeekUtils$ as $c_Lpresto_types$DayOfWeekUtils$ };
$p = $c_Lpresto_types$DayOfWeekUtils$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DayOfWeekUtils$;
/** @constructor */
function $h_Lpresto_types$DayOfWeekUtils$() {
}
export { $h_Lpresto_types$DayOfWeekUtils$ as $h_Lpresto_types$DayOfWeekUtils$ };
$h_Lpresto_types$DayOfWeekUtils$.prototype = $p;
$p.cHm = (function() {
  if ((!this.c4B)) {
    this.c4A = new $j_presto$002etypes$0024$002dDay$002dOf$002dWeek$002dUtils$0024$0024anon$002410.$c_Lpresto_types$DayOfWeekUtils$$anon$10(this);
    this.c4B = true;
  }
  return this.c4A;
});
$p.cH9 = (function() {
  if ((!this.c4z)) {
    this.c4y = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$14(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((str) => {
      try {
        return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Ljava_time_DayOfWeek$().cQp(str));
      } catch (e) {
        var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
        if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().ak(e$2)) {
          return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
        } else {
          throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
        }
      }
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8);
    this.c4z = true;
  }
  return this.c4y;
});
$p.cCs = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$().ag($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Ljava_time_DayOfWeek.r().C)([$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$s_Ljava_time_DayOfWeek$__MONDAY__Ljava_time_DayOfWeek(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$s_Ljava_time_DayOfWeek$__TUESDAY__Ljava_time_DayOfWeek(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$s_Ljava_time_DayOfWeek$__WEDNESDAY__Ljava_time_DayOfWeek(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$s_Ljava_time_DayOfWeek$__THURSDAY__Ljava_time_DayOfWeek(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$s_Ljava_time_DayOfWeek$__FRIDAY__Ljava_time_DayOfWeek()])));
});
var $d_Lpresto_types$DayOfWeekUtils$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DayOfWeekUtils$, "presto.types$DayOfWeekUtils$", ({
  ZM: 1
}));
export { $d_Lpresto_types$DayOfWeekUtils$ as $d_Lpresto_types$DayOfWeekUtils$ };
var $n_Lpresto_types$DayOfWeekUtils$;
function $m_Lpresto_types$DayOfWeekUtils$() {
  if ((!$n_Lpresto_types$DayOfWeekUtils$)) {
    $n_Lpresto_types$DayOfWeekUtils$ = new $c_Lpresto_types$DayOfWeekUtils$();
  }
  return $n_Lpresto_types$DayOfWeekUtils$;
}
export { $m_Lpresto_types$DayOfWeekUtils$ as $m_Lpresto_types$DayOfWeekUtils$ };
//# sourceMappingURL=presto.types$-Day-Of-Week-Utils$.js.map
